import React, { Component } from 'react'
import Predefine_2_Colar_Soccer from '../../assets/components/Predefine_2_Colar_Soccer/Predefine_2_Colar_Soccer'

export class Predefine_2_Colar_SoccerPage extends Component {
  render() {
    return (
     <Predefine_2_Colar_Soccer/>
    )
  }
}

export default Predefine_2_Colar_SoccerPage